import { useNavigate } from 'react-router-dom';
import { BuilderWizard, WizardStep } from '@unwritten/builder';
import { UserCircle } from 'lucide-react';

export function CharacterWizard() {
  const navigate = useNavigate();

  const steps: WizardStep[] = [
    {
      id: 'basics',
      title: 'Basic Info',
      description: 'Set up character name and appearance',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Basic character information form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'attributes',
      title: 'Attributes',
      description: 'Define character attributes and stats',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Character attributes form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'background',
      title: 'Background',
      description: 'Create character backstory',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Background editor coming soon...</p>
        </div>
      ),
    },
    {
      id: 'review',
      title: 'Review',
      description: 'Review and create character',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Review screen coming soon...</p>
        </div>
      ),
    },
  ];

  const handleComplete = async (data: any) => {
    console.log('Character created:', data);
    navigate('/characters');
  };

  const handleCancel = () => {
    navigate('/characters');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center gap-3 mb-6">
        <UserCircle className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Create New Character</h1>
      </div>

      <BuilderWizard
        steps={steps}
        onComplete={handleComplete}
        onCancel={handleCancel}
        persistenceKey="character-wizard"
      />
    </div>
  );
}
